define('app-Cabins/main',['./settings', '../app-blazy/module'], function (settings, blazy) {
    return {
        run: function () {
            var cabinContainer = $(settings.container);

            if (cabinContainer.length === 0) {
                window.log('No cabinContainer found.  cabinContainer will not be available.');
                return;
            }


            //Grade see more
            $('.viewDeck').on('click', function (e) {
                e.preventDefault();
                var currentMasterGrade = $(this).attr('data-mastergrade');
                var currentGradeContent = $(this).closest('.cabin-grade-content');
                $('.carousel').carousel(0);
                //If currently open
                if (currentGradeContent.hasClass('fullView')) {
                    currentGradeContent.find('.cabinsAdditional').slideUp("slow");
                    currentGradeContent.removeClass('fullView');

                    //Hide show profile images
                    var profile = $('.deck-profile[data-mastergrade="' + currentMasterGrade + '"]');
                    $('.row', profile).find('.active').hide();
                    $('.row', profile).find('.default').show();
                }
                //If new, close any others
                else {

                    var slideshow = currentGradeContent.find('.carousel');
                    $(slideshow).find('.carousel-item:hidden, .carousel-item').each(function () {
                        var getSliderSrc = $(this).find('img').attr('data-src');
                        $(this).find('img').attr('src', getSliderSrc);
                    });

                    //Carousel controls
                    sliderControls(slideshow);

                       $('.cabin-grade-content').removeClass('fullView');
                    $('.cabin-grade-content').find('.cabinsAdditional').hide();
                    
                    $("html, body").animate({ scrollTop: $(currentGradeContent).offset().top - 10 }, 'slow', function () {


                        currentGradeContent.addClass('fullView');
                        currentGradeContent.find('.cabinsAdditional').slideDown("slow");
                    });

                    blazy.loadLazy();


                }
                $('.cabinList li').removeClass('activeDeck');

                //Hide show current images
                var getSrc = $('input.imageSrc:hidden[data-deck="deckImageDefault"]').attr('data-src');
                var getAlt = $('input.imageSrc:hidden[data-deck="deckImageDefault"]').attr('data-alt');
                $('#deckImage').attr('src', getSrc).attr('alt', getAlt);
                $("#deckImage").css({ "top": 0 + 'px' });
            });

            //Deck Selector
            $('.gradeDeckPlan').on('click', function (e) {
                e.preventDefault();
                var currentMasterGrade = $(this).attr('data-mastergrade');
                var currentGrade = $(this).attr('data-grade');
                var currentDeck = $(this).attr('data-deck');
                if (!currentGrade.length == 0) {
                    //Hide show deck plan images
                    var getSrc = $('input.imageSrc:hidden[data-deck="' + currentDeck + '"][data-cabin="' + currentGrade + '"][data-mastergrade="' + currentMasterGrade + '"]').attr('data-src');
                    var getAlt = $('input.imageSrc:hidden[data-deck="' + currentDeck + '"][data-cabin="' + currentGrade + '"][data-mastergrade="' + currentMasterGrade + '"]').attr('data-alt');
                    $('#deckImage').attr('src', getSrc).attr('alt', getAlt);
                    $("#deckImage").css({ "top": 0 + 'px' });


                    //Hide show profile images
                    var profile = $('.deck-profile[data-mastergrade="' + currentMasterGrade + '"]');
                    $('.row', profile).find('.active').hide();
                    $('.row', profile).find('.default').show();
                    $('.row[data-profile-image="' + currentDeck + '"]', profile).find('.default').hide();
                    $('.row[data-profile-image="' + currentDeck + '"]', profile).find('.active').show();
                }

                if ($(window).width() >= 992) {
                    $('.cabinList li').removeClass('activeDeck');
                    $(this).parent().addClass('activeDeck');

                    setTimeout(function () {
                        animate();
                    }, 50);
                }
                else {
                    $('.deckplan-images').show();
                    var imageHeight = $('#deckImage').height() / 2 - 100;
                    $(".deckplan-images").animate({ scrollTop: imageHeight }, 0);
                    $(".deckplan-images").animate({ scrollTop: 0 }, 1000);
                    $('html').addClass('scrollFreeze');
                    if (currentGrade.length == 0) {
                        $('.mobileHeader h3').text(currentDeck);
                    }
                    else {
                        $('.mobileHeader h3').text(currentDeck + ' - ' + currentGrade);
                    }
                }
            });

            function animate() {
                /*animate image*/
                var imageheight = $('#deckImage').height();
                var deckFromTop = $('.activeDeck').offset().top - $(".deckplan-content").offset().top - imageheight / 2;
                var deckplanImageHolder = $('.deckplan-images').height();
                if (deckFromTop > deckplanImageHolder - imageheight) {
                    deckFromTop = deckplanImageHolder - imageheight
                }
                if (deckFromTop < 0) {
                    deckFromTop = 0
                }
                $("#deckImage").animate({ "top": deckFromTop + 'px' }, 1000);
            }

            $('.mobileHeader').on('click', function (e) {
                e.preventDefault();
                $('.deckplan-images').hide();
                $('html').removeClass('scrollFreeze');
            });

            function sliderControls(slideshow) {
                var elCarouselItem = $('.carousel-item');
                var currentIndex = slideshow.find('div.active').index() + 1;
                var ti = slideshow.find(elCarouselItem).length;

                if (ti >= 2) {
                    slideshow.find('.carousel-control-holder').show();
                    var prevSlide = slideshow.find('.carousel-control-prev');
                    var nextSlide = slideshow.find('.carousel-control-next');
                    if (currentIndex == 1) {
                        prevSlide.addClass('disabled');
                        nextSlide.removeClass('disabled');
                    } else if (currentIndex == ti) {
                        nextSlide.addClass('disabled');
                        prevSlide.removeClass('disabled');
                    }
                    else {
                        prevSlide.removeClass('disabled');
                        nextSlide.removeClass('disabled');
                    }
                }
            }

            $('.carousel').on('slid.bs.carousel', function (e) {
                var slideshow = $(this);
                sliderControls(slideshow);
            });




            function getParameterByName(name) {
                name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
                var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
                    results = regex.exec(location.search);
                return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
            }




        }
    }
});
